/**
 * Client-side username blocklist (keep in sync with functions/usernameBlocklist.js).
 * UX-only; authoritative checks run in reserveUsername callable.
 */

const BLOCKED_SUBSTRINGS = [
  'support',
  'admin',
  'pxc',
  'pedalxchange',
  'pedalteam',
  'pedalstaff',
  'pedalsupport',
  'pxcteam',
  'pxcstaff',
  'pxcsupport',
  'pxcadmin',
];

export function canonicalizeForBlocklist(raw) {
  if (!raw || typeof raw !== 'string') return '';
  let s = raw.trim().toLowerCase();
  s = s.replace(/0/g, 'o').replace(/1/g, 'l').replace(/3/g, 'e');
  s = s.replace(/[-_\s]/g, '');
  return s;
}

export function isUsernameBlocklisted(raw) {
  const c = canonicalizeForBlocklist(raw);
  if (!c) return false;
  return BLOCKED_SUBSTRINGS.some((frag) => c.includes(frag));
}

export { BLOCKED_SUBSTRINGS };
